import {take, values} from 'lodash';

export const AWS_REGIONS = {
  AP_NORTHEAST_1: 'ap-northeast-1',
  AP_SOUTHEAST_2: 'ap-southeast-2',
  CA_CENTRAL_1: 'ca-central-1',
  EU_CENTRAL_1: 'eu-central-1',
  IVM_STAGING: 'ivm-stage-0',
  US_EAST_1: 'us-east-1',
  US_EAST_2: 'us-east-2',
  US_WEST_2: 'us-west-2',
};

export const defaultIVMRegion = 'US2';
export const ivmStagingRegion = 'ivm-staging';

export const regions = Object.freeze({
  [AWS_REGIONS.AP_NORTHEAST_1]: 'AP',
  [AWS_REGIONS.AP_SOUTHEAST_2]: 'AU',
  [AWS_REGIONS.CA_CENTRAL_1]: 'CA',
  [AWS_REGIONS.EU_CENTRAL_1]: 'EU',
  [AWS_REGIONS.IVM_STAGING]: ivmStagingRegion,
  [AWS_REGIONS.US_EAST_1]: 'US',
  [AWS_REGIONS.US_EAST_2]: defaultIVMRegion,
  [AWS_REGIONS.US_WEST_2]: 'US3',
});

export function getLongFormRegion(shortForm) {
  return Object.keys(regions).find(
    (key) => regions[key]?.toLowerCase() === shortForm
  );
}

export function stripAWSRegionNumber(region) {
  return take(region.split('-'), 2).join('-');
}

export const REGION_VALUES = values(AWS_REGIONS);
export const REGION_ABBREVIATION_VALUES = values(regions);

const regionsPattern = REGION_ABBREVIATION_VALUES.map((region) =>
  region.toLowerCase()
)
  .sort((a, b) => (a > b ? -1 : 1))
  .join('|');

const stagingPattern = new RegExp(ivmStagingRegion);

function getRegionMatchFromBucket(cdnBucket) {
  const pattern = new RegExp(regionsPattern);
  const match = cdnBucket.match(pattern);

  return match ? match[0] : '';
}

export default function getAWSShortRegion(cdnBucket) {
  if (cdnBucket) {
    const region = getRegionMatchFromBucket(cdnBucket);

    if (region === ivmStagingRegion) {
      return ivmStagingRegion;
    }

    return stripAWSRegionNumber(getLongFormRegion(region));
  }

  return '';
}

export function getIVMRegion(cdnBucket) {
  if (cdnBucket) {
    const awsRegion = getRegionMatchFromBucket(cdnBucket);

    if (cdnBucket.match(stagingPattern)) {
      return regions[AWS_REGIONS.IVM_STAGING]; //no IVM region for staging
    }

    return regions[getLongFormRegion(awsRegion)] || defaultIVMRegion;
  }

  return defaultIVMRegion;
}
